import { useDelay, useInstance, useView } from '@10000/react'
import { Body, Box, CenteredBox, H1, H3, H4, Interaction, QR } from '../../widgets'
import { useBackground, useShell } from '../../layout'

const kioskContent = {
  solo: [
    `Think of a team you currently work in.`,
    `Answer the 6 questions based on your experience in that team.`,
    `When done, you can review the results for your impression of the team.`
  ],
  team: [
    `Think of a team you all currently work in.`,
    <><p style={{ margin: '0 0 8px 0' }}>You will be presented with 3 questions in Standard mode and Consensus mode.</p><p style={{ margin: 0 }}>Answer the questions based on your experience in that team.</p></>,
    `When done, you can review the results for your team.`
  ]
}

export const Splash = ({ active }) => {
  const { options: { kiosk, solo } = {} } = useView('squiz')
  const { id, region } = useInstance()
  const hideText = useDelay(10000)

  useShell({ active, footer: true })
  useBackground().set({ active, background: 4, size: '1213px 1163px', position: 'left -166px bottom -83px' })

  return (
    <Box fullWidth fullHeight>
      {kiosk &&
        <CenteredBox width={877} background="linear-gradient(180deg, #000 29.83%, rgba(0, 0, 0, 0.00) 179%)" fullHeight>
          <Box column maxWidth={500} gap={72}>
            <H3>You selected {solo ? 'Solo' : 'Team'} Mode</H3>
            <Box column>
              <H4 align="left">Here&apos;s how to play:</H4>
              <Body alt size={24} lineHeight="32px">
                <ol style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                  {kioskContent[solo ? 'solo' : 'team'].map((point, i) =>
                    <li key={i}>{point}</li>
                  )}
                </ol>
              </Body>
            </Box>

            <H4 align="left" lineHeight="32px">
              Grab your phone, when you&apos;re ready, scan this QR code to begin.
            </H4>
          </Box>
        </CenteredBox>
      }

      <CenteredBox grow column gap={80} p={400}>
        <QR size={600} instanceId={id} region={region} />
      </CenteredBox>

      <Box position="absolute" inset justifyContent="center" opacity={hideText ? 0 : 1} transition="opacity 0.5s">
        <Box p={16} r={16} mt={16} style={{ backdropFilter: 'blur(5px)' }} height="fit-content">
          <H1 underline align="center">Please move this tab<br/>to your extended screen</H1>
        </Box>
      </Box>

      <Interaction />
    </Box>
  )
}